import { render, staticRenderFns } from "./SyncList.vue?vue&type=template&id=66835dd9&scoped=true"
import script from "./SyncList.vue?vue&type=script&lang=js"
export * from "./SyncList.vue?vue&type=script&lang=js"
import style0 from "./SyncList.vue?vue&type=style&index=0&id=66835dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66835dd9",
  null
  
)

export default component.exports